export interface ISubfiltros {
  campo: string;
  label: string;
  expandido: boolean;
  valoresSubFiltroResponseDTO: ISubFiltroValue[];
}

interface ISubFiltroValue {
  checked: boolean;
  descricao: string;
  quantidade: string;
}

interface IResultado {
  [campo: string]: string[];
}

export const transformarDadosSubFilter = (dados: ISubfiltros[]): IResultado => {
  const resultado: IResultado = {};

  dados.forEach((item) => {
    const valoresFiltrados = item.valoresSubFiltroResponseDTO
      .filter((subItem) => subItem.checked)
      .map((subItem) => subItem.descricao);

    resultado[item.campo] = valoresFiltrados;
  });

  return resultado;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const verificarSePossuiItensSelecionadosOuExpandidos: any = (
  filtroAtualizado?: ISubfiltros[],
  filtroAntigo?: ISubfiltros[]
) => {
  if (!filtroAtualizado || !filtroAntigo) return [];

  const novoFiltro = filtroAtualizado.map((categoriaAtual) => {
    const campo = categoriaAtual.campo;
    const categoriaAntiga = filtroAntigo.find((old) => old.campo === campo);

    const subFiltroAntigo = categoriaAntiga!.valoresSubFiltroResponseDTO;
    const expandido = categoriaAntiga!.expandido || false;

    const valoresAtualizados = categoriaAtual.valoresSubFiltroResponseDTO.map(
      (itemAtual) => {
        const valorAntigo = subFiltroAntigo.find(
          (valor) => valor.descricao === itemAtual.descricao
        );
        return {
          ...itemAtual,
          checked: valorAntigo?.checked ? valorAntigo?.checked : false,
        };
      }
    );

    return {
      ...categoriaAtual,
      campo,
      valoresSubFiltroResponseDTO: valoresAtualizados,
      expandido,
    };
  });
  return novoFiltro;
};
